import { render, staticRenderFns } from "./PortalRfxDetail.vue?vue&type=template&id=1e88a1a6"
import script from "./PortalRfxDetail.vue?vue&type=script&lang=js"
export * from "./PortalRfxDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports